import axios from "axios";
import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Cookies from "js-cookie";
import { motion } from "framer-motion";
import { DEFAULT_AVATAR } from "../../../utils/fallbackImages";

export default function DetailMessageInbox() {
  const [MessageUser, setMessageUser] = useState(null);
  const [messageData, setMessageData] = useState(null);
  const session_id = Cookies.get("jwt");
  const messageID = sessionStorage.getItem("messageID");

  function getData() {
    if (messageID) {
      axios
        .post(
          `${process.env.REACT_APP_API}/inbox/readMessage`,
          { messageId: messageID },
          { headers: { Authorization: `Bearer ${session_id}` } }
        )
        .then((res) => {
          setMessageData(res.data.message.message);
          setMessageUser(res.data.message.user);
        });
    }
  }

  useEffect(() => { getData(); }, []);
  useEffect(() => { getData(); }, [messageID]);

  if (MessageUser == null || messageData == null) {
    setTimeout(() => { getData(); }, 1000);
    return (
      <div className="min-h-screen bg-gray-50 lg:pt-20 flex items-center justify-center">
        <div className="flex flex-col items-center gap-3 text-gray-400">
          <svg className="animate-spin w-8 h-8 text-blue-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
          </svg>
          <p className="text-sm">กำลังโหลด...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 lg:pt-20">
      <div className="max-w-2xl mx-auto px-4 py-8 space-y-4">

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 px-5 py-4 flex items-center gap-3"
        >
          <Link to="/notifications">
            <div className="w-9 h-9 bg-gray-50 rounded-xl flex items-center justify-center border border-gray-100 hover:bg-gray-100 transition-colors flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
              </svg>
            </div>
          </Link>
          <div>
            <p className="text-xs text-gray-400 uppercase tracking-wider mb-0.5">การแจ้งเตือน</p>
            <h1 className="text-lg font-bold text-gray-900 truncate">{messageData.title}</h1>
          </div>
        </motion.div>

        {/* Sender card */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.04 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 px-5 py-4 flex items-center gap-3"
        >
          <img
            src={MessageUser.sender.profile_image}
            alt={MessageUser.sender.uname}
            className="w-10 h-10 rounded-full object-cover ring-2 ring-white shadow-sm flex-shrink-0"
            onError={(e) => { e.target.src = DEFAULT_AVATAR; }}
          />
          <div className="flex-1 min-w-0">
            <p className="text-xs text-gray-400 mb-0.5">จาก</p>
            <p className="text-sm font-semibold text-gray-800">{MessageUser.sender.uname}</p>
          </div>
          <div className="text-right">
            <p className="text-xs text-gray-400 mb-0.5">ถึง</p>
            <p className="text-sm font-semibold text-gray-800">{MessageUser.receiver.uname}</p>
          </div>
        </motion.div>

        {/* Message body */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.08 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 px-5 py-5"
        >
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">ข้อความ</p>
          <p className="text-sm text-gray-700 leading-relaxed whitespace-pre-wrap">{messageData.description}</p>
        </motion.div>

        <div className="h-8" />
      </div>
    </div>
  );
}
